import { useQuery } from "@tanstack/react-query";
import { AIAgentDefinitions } from "@graylog/enterprise-api";
import { defaultOnError } from "util/conditional/onError";
const WORKFLOW_TYPES_QUERY_KEY = ["aiagent", "workflow-definitions", "usage-options"];
const fetchWorkflowTypeOptions = () => defaultOnError(
  AIAgentDefinitions.paginated(1, 1e3, "title", "asc", "", void 0),
  "Loading workflow definitions failed",
  "Could not load workflow definitions"
).then(
  ({ elements }) => elements.map((workflow) => ({
    value: workflow.id,
    label: workflow.title || workflow.id
  })).sort((a, b) => a.label.localeCompare(b.label))
);
const useWorkflowTypeOptions = () => {
  const { data, isLoading, isFetching } = useQuery({
    queryKey: WORKFLOW_TYPES_QUERY_KEY,
    queryFn: fetchWorkflowTypeOptions,
    staleTime: 6e4
  });
  return { data: data != null ? data : [], isLoading: isLoading || isFetching };
};
export default useWorkflowTypeOptions;
